<template>
    <ModalComponent
        :name="name"
        title="Descargar informe control de acceso"
        v-on:close="() => close(false)"
    >
        <div class="card-body">
            <div class="row" v-if="!mensaje">
                <div class="col-12">
                    <h4>Haga clic aquí para descargar el informe de control de accesos para esta sesión</h4>
                </div>
                <div class="col-12  ">
                    <Button @click="getInforme()">DESCARGAR</Button>
                </div>
            </div>
            <div v-else>
                <h4>{{ mensaje }}</h4>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";

export default {
    props: ['evento', 'sesion_id', 'taquillero_id', 'name'],
    data() {
        return {
            loading: false,
            mensaje: null
        }
    },
    methods: {
        close() {
            this.$emit('close', this.name);
            this.mensaje = null;
        },
        getInforme : function() {
            this.loading = true;
            const params = {
                filters : {
                    evento_id: this.evento.id,
                    taquillero_id: this.taquillero_id,
                    sesion_id: this.sesion_id
                },
                evento_id: this.evento.id
            };
            this.$store.dispatch(this.config.getVuexAlias('back.events.informe.control'), params).then(res => {
                this.mensaje = res.data.message;
            });
        }
    },
    components: {
        ModalComponent
    }
}
</script>
